import { Entity, Column, PrimaryGeneratedColumn, CreateDateColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('threads_embroidery')
export class ThreadsEmbroideryEntity {
    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('varchar', {
        name: 'product_code',
        length: 15
    })
    productCode: string;

    @Column('varchar', {
        name: 'color',
        length: 225
    })
    color: string;

    @Column('varchar', {
        name: 'shade_number',
        length: 15
    })
    shadeNumber: string;

    @Column('varchar', {
        name: 'tex',
        length: 50
    })
    tex: string;

    @Column('float', {
        name: 'consumption'
    })
    consumption: number;

    @Column('varchar', {
        name: 'mtrs_per_cone',
        length: 10
    })
    mtrsPerCone: string;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column('boolean', {
        nullable: false,
        name: 'is_active',
        default: true
    })
    isActive: boolean;
}
